import { useEffect, useState } from "react";
import { Form, OverlayTrigger, Tooltip } from "react-bootstrap";
import axios from "axios";
import * as Sentry from "@sentry/nextjs";
import ActivityReasonForApplying from "./ActivityReasonForApplying";

export default function ActivityInputs({ state, onChange }) {
  const [activityPrimaryActivity, setActivityPrimaryActivity] = useState(state.activityPrimaryActivity || "");
  const [activitySpecificProducts, setActivitySpecificProducts] = useState(state.activitySpecificProducts || "");
  const [productExtraQuestion1, setProductExtraQuestion1] = useState(state.productExtraQuestion1 || "");
  const [productExtraQuestion2, setProductExtraQuestion2] = useState(state.productExtraQuestion2 || "");
  const [productExtraQuestion3, setProductExtraQuestion3] = useState(state.productExtraQuestion2 || "");
  const [activityPrimaryActivities, setActivityPrimaryActivities] = useState([]);

  useEffect(() => {
    async function fetchData() {
      try {
        const result = await axios.get(
          process.env.NEXT_PUBLIC_REACT_APP_API + "/category/EIN/products/primary-activity"
        );

        setActivityPrimaryActivities(result.data);
      } catch (e) {
        try {
          let salePage = window.location.href;
          let salePageURLArr = salePage.split("/");
          let salePageURL = (salePageURLArr[0] + "//" + salePageURLArr[2]).replace(
            /\/+$/,
            ""
          );
          const res2 = await axios.get(salePageURL + "/crm/category/EIN/products/primary-activity");
          setActivityPrimaryActivities(res2.data);
        } catch (e2) {
          Sentry.captureException(new Error("Primary Activity unavailable"), { tags: { section: "products" } });
        }
      }
    }

    fetchData();
  }, []);

  useEffect(() => {
    if (state) setActivityPrimaryActivity(state.activityPrimaryActivity);
  }, [state]);

  useEffect(() => {
    if (state.activitySpecificProducts) setActivitySpecificProducts(state.activitySpecificProducts);
  }, [state.activitySpecificProducts]);

  useEffect(() => {
    if (state.productExtraQuestion1) setProductExtraQuestion1(state.productExtraQuestion1);
  }, [state.productExtraQuestion1]);

  useEffect(() => {
    if (state.productExtraQuestion2) setProductExtraQuestion2(state.productExtraQuestion2);
  }, [state.productExtraQuestion2]);

  useEffect(() => {
    if (state.productExtraQuestion3) setProductExtraQuestion3(state.productExtraQuestion3);
  }, [state.productExtraQuestion3]);

  function handleSpecificProductsChange(event) {
    const newValues = {
      productExtraQuestion1: null,
      productExtraQuestion2: null,
      productExtraQuestion3: null,
      productDescription: null,
    };

    setActivitySpecificProducts(event.target.value);
    setProductExtraQuestion1("");
    setProductExtraQuestion2("");
    setProductExtraQuestion3("");
    onChange(event, newValues);
  }

  function handleproductExtraQuestion1(event) {
    const newValues = {
      productExtraQuestion2: null,
      productExtraQuestion3: null,
      productDescription: null,
    };

    setProductExtraQuestion1(event.target.value);
    setProductExtraQuestion2("");
    setProductExtraQuestion3("");
    onChange(event, newValues);
  }

  function handleproductExtraQuestion2(event) {
    const newValues = {
      productExtraQuestion3: null,
      productDescription: null,
    };

    setProductExtraQuestion2(event.target.value);
    setProductExtraQuestion3("");
    onChange(event, newValues);
  }

  function handleproductExtraQuestion3(event) {
    const newValues = {
      productDescription: null,
    };

    setProductExtraQuestion3(event.target.value);
    onChange(event, newValues);
  }

  function handleProductDescription(event) {
    onChange(event);
  }

  function handlePrimaryChange(event) {
    const newValues = {
      activitySpecificProducts: null,
    };

    setActivityPrimaryActivity(event.target.value);
    setActivitySpecificProducts("");
    onChange(event, newValues);
  }

  const getActiviteSpecificProductsLabel = (product) => {
    const specificProduct = product.specificProducts.filter(({ code }) => code === activitySpecificProducts)[0];

    return specificProduct && specificProduct.labelForDescriptionField ? (
      <Form.Group controlId="productDescription">
        <Form.Label>{specificProduct.labelForDescriptionField}</Form.Label>
        <Form.Control
          required
          data-hj-allow
          type="text"
          placeholder={specificProduct.labelForDescriptionField}
          maxLength="50"
          pattern="^[a-zA-Z][ a-zA-Z]{1,50}$"
          value={state.productDescription}
          onKeyPress={(event) => {
            if (!/[ a-zA-Z]/.test(event.key)) event.preventDefault();
          }}
          onChange={handleProductDescription}
        />
        <Form.Control.Feedback type="invalid">{specificProduct.labelForDescriptionField}</Form.Control.Feedback>
      </Form.Group>
    ) : null;
  };

  const getActiviteSpecificProductsExtraLabel = (specificProduct, productExtraQuestion1) => {
    const extraQuestions = specificProduct.extraQuestionOptions.filter(({ code }) => code === productExtraQuestion1)[0];

    return extraQuestions && extraQuestions.labelForDescriptionField ? (
      <Form.Group controlId="productDescription">
        <Form.Label>{extraQuestions.labelForDescriptionField}</Form.Label>
        <Form.Control
          required
          data-hj-allow
          type="text"
          placeholder={extraQuestions.labelForDescriptionField}
          maxLength="50"
          pattern="^[a-zA-Z][ a-zA-Z]{1,50}$"
          value={state.productDescription}
          onKeyPress={(event) => {
            if (!/[ a-zA-Z]/.test(event.key)) event.preventDefault();
          }}
          onChange={handleProductDescription}
        />
        <Form.Control.Feedback type="invalid">{extraQuestions.labelForDescriptionField}</Form.Control.Feedback>
      </Form.Group>
    ) : null;
  };

  const getActiviteSpecificProductsExtraProduct2 = (product, codes, id, handler) => {
    const specificProduct = product.extraQuestionOptions.filter(({ code }) => code === codes)[0];

    return specificProduct && specificProduct.extraQuestion ? (
      <>
        <Form.Group controlId={id}>
          <Form.Label>{specificProduct.extraQuestion}</Form.Label>
          <Form.Control as="select" required defaultValue={state[id]} onChange={handler}>
            <option value="">Please Select</option>
            {specificProduct.extraQuestionOptions.map((m) => (
              <option key={m.code} value={m.code}>
                {m.label}
              </option>
            ))}
          </Form.Control>
          <Form.Control.Feedback type="invalid">Please select</Form.Control.Feedback>
        </Form.Group>
        {getActiviteSpecificProductsExtraLabel(specificProduct, productExtraQuestion3)}
      </>
    ) : null;
  };

  const getActiviteSpecificProductsExtraProduct1 = (product, codes, id, handler) => {
    const specificProduct = product.extraQuestionOptions.filter(({ code }) => code === codes)[0];

    return specificProduct && specificProduct.extraQuestion ? (
      <>
        <Form.Group controlId={id}>
          <Form.Label>{specificProduct.extraQuestion}</Form.Label>
          <Form.Control as="select" required defaultValue={state[id]} onChange={handler}>
            <option value="">Please Select</option>
            {specificProduct.extraQuestionOptions.map((m) => (
              <option key={m.code} value={m.code}>
                {m.label}
              </option>
            ))}
          </Form.Control>
          <Form.Control.Feedback type="invalid">Please select</Form.Control.Feedback>
        </Form.Group>
        {getActiviteSpecificProductsExtraLabel(specificProduct, productExtraQuestion2)}
        {getActiviteSpecificProductsExtraProduct2(
          specificProduct,
          productExtraQuestion2,
          "productExtraQuestion3",
          handleproductExtraQuestion3
        )}
      </>
    ) : null;
  };

  const getActiviteSpecificProductsExtra = (product, id) => {
    const specificProduct = product.specificProducts.filter(({ code }) => code === activitySpecificProducts)[0];

    return specificProduct && specificProduct.extraQuestion ? (
      <>
        <Form.Group controlId={id}>
          <Form.Label>{specificProduct.extraQuestion}</Form.Label>
          <Form.Control as="select" required defaultValue={state[id]} onChange={handleproductExtraQuestion1}>
            <option value="">Please Select</option>
            {specificProduct.extraQuestionOptions.map((m) => (
              <option key={m.code} value={m.code}>
                {m.label}
              </option>
            ))}
          </Form.Control>
          <Form.Control.Feedback type="invalid">Please select</Form.Control.Feedback>
        </Form.Group>
        {getActiviteSpecificProductsExtraLabel(specificProduct, productExtraQuestion1)}
        {getActiviteSpecificProductsExtraProduct1(
          specificProduct,
          productExtraQuestion1,
          "productExtraQuestion2",
          handleproductExtraQuestion2
        )}
      </>
    ) : null;
  };

  const getLabelForDescriptionFieldPrimary = () => {
    const activityPrimaryActivitie = activityPrimaryActivities.filter(
      ({ code }) => code === activityPrimaryActivity
    )[0];

    return activityPrimaryActivitie && activityPrimaryActivitie.labelForDescriptionField ? (
      <div>
        <Form.Group controlId="productDescription">
          <Form.Label>{activityPrimaryActivitie.labelForDescriptionField}</Form.Label>
          <Form.Control
            required
            data-hj-allow
            type="text"
            placeholder={activityPrimaryActivitie.labelForDescriptionField}
            maxLength="50"
            pattern="^[a-zA-Z][ a-zA-Z]{1,50}$"
            value={state.productDescription}
            onKeyPress={(event) => {
              if (!/[ a-zA-Z]/.test(event.key)) event.preventDefault();
            }}
            onChange={handleProductDescription}
          />
          <Form.Control.Feedback type="invalid">
            {activityPrimaryActivitie.labelForDescriptionField}
          </Form.Control.Feedback>
        </Form.Group>
      </div>
    ) : null;
  };

  const getActivitySpecificProducts = () => {
    const activityPrimaryActivitie = activityPrimaryActivities.filter(
      ({ code }) => code === activityPrimaryActivity
    )[0];

    return (
      <>
        {activityPrimaryActivitie === undefined || activityPrimaryActivitie.code === "" ? (
          ""
        ) : (
          <>
            {getLabelForDescriptionFieldPrimary()}
            {activityPrimaryActivitie.specificProducts.length > 0 && (
              <>
                <OverlayTrigger
                  rootClose
                  placement="right-start"
                  overlay={
                    <Tooltip id="overlay-example" className="helpTooltip">
                      <strong>Specific Products/Services</strong>
                      <br />
                      Enter the specific products/services of the{" "}
                      {state.code === "EIN_Church"
                        ? "Church"
                        : state.code === "EIN_NonProfit"
                        ? "Non Profit"
                        : "business"}
                      .<br />
                      <strong>If you own a computer repair business you could enter “computer repair services”.</strong>
                    </Tooltip>
                  }
                >
                  <Form.Group controlId="activitySpecificProducts">
                    {activityPrimaryActivitie.specificProductsLabel ? (
                      <Form.Label>{activityPrimaryActivitie.specificProductsLabel}</Form.Label>
                    ) : (
                      <Form.Label>Specific Products/Services</Form.Label>
                    )}
                    <Form.Control
                      as="select"
                      required
                      defaultValue={state.activitySpecificProducts}
                      onChange={handleSpecificProductsChange}
                    >
                      <option value="">Please Select</option>
                      {activityPrimaryActivitie.specificProducts.map((m) => (
                        <option key={m.code} value={m.code}>
                          {m.label}
                        </option>
                      ))}
                    </Form.Control>
                    <Form.Control.Feedback type="invalid">
                      Please describe the products sold or services provided
                    </Form.Control.Feedback>
                  </Form.Group>
                </OverlayTrigger>
                {getActiviteSpecificProductsLabel(activityPrimaryActivitie)}
                {getActiviteSpecificProductsExtra(activityPrimaryActivitie, "productExtraQuestion1")}
              </>
            )}
          </>
        )}
      </>
    );
  };

  return (
    <div>
      <h5>Activity</h5>
      <ActivityReasonForApplying state={state} onChange={onChange}/>
      <OverlayTrigger
        rootClose
        placement="right-start"
        overlay={
          <Tooltip id="overlay-example" className="helpTooltip">
            <strong>Primary Activity</strong>
            <br />
            Describe your type of business and primary activity and services you do or will provide.
          </Tooltip>
        }
      >
        <Form.Group controlId="activityPrimaryActivity">
          <Form.Label>Primary Activity</Form.Label>
          <Form.Control as="select" required value={state.activityPrimaryActivity || ""} onChange={handlePrimaryChange}>
            <option value="">Please Select</option>
            {activityPrimaryActivities
              ? activityPrimaryActivities.map(({ code, label }) => (
                  <option value={code} key={code}>
                    {label}
                  </option>
                ))
              : ""}
          </Form.Control>
          <Form.Control.Feedback type="invalid">Please select the business activity</Form.Control.Feedback>
        </Form.Group>
      </OverlayTrigger>
      {getActivitySpecificProducts()}
    </div>
  );
}
